if (!customElements.get('sht-prd-recom')) {
  class SakuraProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.dataset.loaded === 'true') return;

      this.setAttribute('aria-busy', 'true');
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.loadRecommendations();
        }, { rootMargin: '300px 0px' });
        this.observer.observe(this);
      } else {
        this.loadRecommendations();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async loadRecommendations() {
      if (this.loading || this.dataset.loaded === 'true') return;
      this.loading = true;

      try {
        const response = await fetch(this.dataset.url, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = documentFragment.querySelector('sht-prd-recom');
        if (!replacement) throw new Error('Recommendation response did not contain the expected element');

        this.innerHTML = replacement.innerHTML;
        this.querySelectorAll('.js-animate, .js-seq-animate').forEach((element) => {
          element.classList.add('animated');
        });
        this.dataset.loaded = 'true';
        this.removeAttribute('data-error');
      } catch (error) {
        this.dataset.error = 'true';
        console.warn('Product recommendations could not be loaded.', error);
      } finally {
        this.loading = false;
        this.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('sht-prd-recom', SakuraProductRecommendations);
}
